export type BookingFeedbackMoment =
  | "new_booking"
  | "booking_confirmed"
  | "rebooking_ready";

const STORAGE_KEY = "hb_booking_feedback_enabled";

export function bookingFeedbackEnabled(): boolean {
  return localStorage.getItem(STORAGE_KEY) === "true";
}

export function setBookingFeedbackEnabled(enabled: boolean): void {
  localStorage.setItem(STORAGE_KEY, String(enabled));
}

export function canPlayBookingFeedback(enabled: boolean): boolean {
  return (
    enabled &&
    document.visibilityState === "visible" &&
    !window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

/** Local, opt-in, reduced-motion-aware cue; it never fetches or uploads audio. */
export function playBookingFeedback(
  moment: BookingFeedbackMoment,
  enabled = bookingFeedbackEnabled(),
): void {
  if (!canPlayBookingFeedback(enabled)) return;
  try {
    const context = new AudioContext();
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    const frequency =
      moment === "new_booking"
        ? 523.25
        : moment === "booking_confirmed"
          ? 659.25
          : 783.99;
    oscillator.type = "sine";
    oscillator.frequency.value = frequency;
    gain.gain.setValueAtTime(0.0001, context.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.035, context.currentTime + 0.015);
    gain.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + 0.16);
    oscillator.connect(gain).connect(context.destination);
    oscillator.start();
    oscillator.stop(context.currentTime + 0.17);
    oscillator.addEventListener("ended", () => void context.close());
    if (navigator.vibrate) navigator.vibrate(18);
  } catch {
    // Browser audio permission and haptics are optional local enhancements.
  }
}
